<template>
    <div class="login-container">
      <el-card class="login-card">
        <template #header>
          <h2>登录</h2>
        </template>
        <el-form :model="loginForm" @submit.prevent="handleLogin">
          <el-form-item>
            <el-input v-model="loginForm.username" placeholder="用户名" />
          </el-form-item>
          <el-form-item>
            <el-input v-model="loginForm.password" type="password" placeholder="密码" />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" native-type="submit" block>登录</el-button>
          </el-form-item>
        </el-form>
        <div class="register-link">
          还没有账号？<el-link type="primary" @click="$router.push('/register')">立即注册</el-link>
        </div>
      </el-card>
    </div>
  </template>
  
  <script setup>
  import { ref } from 'vue'
  import { useRouter } from 'vue-router'
  import userApi from '@/api/userApi.js'
  import { useUserStore } from '@/stores/user'
  
  const userStore = useUserStore()
  const router = useRouter()
  
  const loginForm = ref({
    username: '',
    password: ''
  })
  
  const handleLogin = () => {
    userApi.login({
      username: loginForm.value.username,
      password: loginForm.value.password
    }).then((r)=>{
      if (r.code == 200) {
        userStore.login(r.data.user, r.data.token)
        console.log(userStore.user, userStore.token)
      }
    })
    
    router.push('/')
  }
  </script>
  
  <style scoped>
  .login-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    background-color: #121212;
  }
  
  .login-card {
    width: 300px;
    background-color: #1a1a1a;
    color: #ffffff;
  }
  
  .register-link {
    text-align: center;
    margin-top: 16px;
  }
  </style>